import FJProductToVideoStart from './FJProductToVideoStart';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import useLocalStore from '../../../hooks/useLocalStore';
import { setSliceProductUrlToVideoInput } from '../../../redux/slices/FJSliceTextToVideo';
const FJProductToVideoStartContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const productUrlToVideoInput = useSelector(state => state.textToVideo.productUrlToVideoInput);
    const onAnalyzeProductUrl = useCallback(() => {
        dispatch(FJActionTextToVideo.onAnalyzeProductUrlAction());
    }, [dispatch]);
    const onChangeProductUrlToVideoInput = useCallback(
        url => {
            dispatch(setSliceProductUrlToVideoInput(url));
        },
        [dispatch],
    );
    const uploadManually = useCallback(() => {
        dispatch(FJActionTextToVideo.onGotoProductInfoEditAction(true));
    }, [dispatch]);
    return (
        <FJProductToVideoStart
            productUrlToVideoInput={productUrlToVideoInput}
            onAnalyzeProductUrl={onAnalyzeProductUrl}
            onChangeProductUrlToVideoInput={onChangeProductUrlToVideoInput}
            uploadManually={uploadManually}
        />
    );
};

export default FJProductToVideoStartContainer;
